import { UPDATE_DATA } from "./types";

export const clearUpdate = () => async dispatch => {
  //console.log('inside clearupdate');
  dispatch({ type: UPDATE_DATA, payload: {} });
};



// WEBPACK FOOTER //
// ./src/actions/common.js